export default new class {

	downloadSendCloudPdf(sendcloudParcelId) {
		const url = 'orders/ship/sendcloud/label';
		const params = {
			parcel_id: sendcloudParcelId
		}

		this.downloadPdf(url, params);
	}

	downloadInvoicePdf(id, type) {
		const url = 'orders/invoice/download';
		const params = {
			order_id: id,
			type
		}

		this.downloadPdf(url, params);
	}

	downloadVvbLabelPdf(orderId, deliveryOptionId) {
		return new Promise((resolve, reject) => {

			const url = 'orders/ship/vvb/download';
			const params = {
				order_id: orderId,
				order_bol_delivery_options_id: deliveryOptionId,
			}

			this.downloadPdf(url, params);

			setTimeout(resolve,500);
		});
	}

	downloadVvbBulkLabelsPdf(orderIds) {
		return new Promise((resolve, reject) => {
			const url = 'orders/ship/vvb/download';
			const params = {
				order_ids: orderIds.join(',')
			}

			this.downloadPdf(url, params);

			setTimeout(resolve, 500);
		});
	}

	downloadPdf(url, params) {
		let requestParams = {
			token: localStorage.getItem('token')
		}

		if (params) {
			requestParams = Object.assign({}, requestParams, params);
		}

		requestParams = new URLSearchParams(requestParams);

		window.open(process.env.VUE_APP_API_URL + url + '?' + requestParams.toString(), '_blank');
	}
}
